export type PermissionKey =
	| 'ONLINE_EDUCATION_MODULE_INSTANCE'
	| 'FORUM'
	| 'SPEEDQUIZ_PLUGIN_WHO_KNOWS_MOST_GENERAL'
	| 'MASTER_RUN'
	| 'ONLINEEDUCATION'
	| 'NOTIFICATION'
	| 'EVENT'
	| 'JOURNEY'
	| 'ENGAGE_MENU_ITEM'
	| 'CONTAINER_PLACEHOLDER_INSTANCE'
	| 'CMS_PAGE_MODULE_INSTANCE'
	| 'TEMPLATE'
	| 'TEMPLATE_READ'
	| 'TEMPLATE_WRITE'
	| 'MISSION'
	| 'BLOG_ENTRY_MODULE_INSTANCE'
	| 'MEDIABANK'
	| 'SPEEDQUIZ_PLUGIN_GENERAL'
	| 'CMS_PAGE'
	| 'CERTIFICATE'
	| 'MEDIABANK_DEFAULTS'
	| 'CONTAINER_MODULE_INSTANCE'
	| 'JOURNEY_COLLECTION'
	| 'BLOG'
	| 'ENGAGE_OBJECT'
	| 'NOTIFICATION_ENGINE_CONFIG'
	| 'DOCUMENT_CATEGORY'
	| 'DOCUMENT_OWNER'
	| 'DOCUMENT_WRITER'
	| 'DOCUMENT_APPROVER'
	| 'FLOW'
	| 'CHATROOM'
	| 'AUTOMATION'
	| 'SUB_PERMISSION';

export type PermissionLegacy = {
	Id?: number;
	Key: PermissionKey;
	ItemId?: number;
	UserId?: number;
	UnitId?: number;
	RoleId?: number;
	CultureId?: number;
	IsPublic?: boolean;
	Name?: string;
	RelationId?: number;
	SubPermissions?: PermissionLegacy[];
};

//camel case version
export type Permission = {
	id?: number;
	key: PermissionKey;
	itemId?: number;
	userId?: number;
	unitId?: number;
	roleId?: number;
	cultureId?: number;
	isPublic?: boolean;
	name?: string;
	relationId?: number;
	subPermissions?: Permission[];
};

export function mapToLegacyPermission(ccPermission: Permission): PermissionLegacy {
	return {
		Id: ccPermission.id,
		Key: ccPermission.key,
		ItemId: ccPermission.itemId,
		UserId: ccPermission.userId,
		UnitId: ccPermission.unitId,
		RoleId: ccPermission.roleId,
		CultureId: ccPermission.cultureId,
		IsPublic: ccPermission.isPublic,
		Name: ccPermission.name,
		RelationId: ccPermission.relationId,
		SubPermissions: ccPermission.subPermissions?.map(mapToLegacyPermission),
	};
}

export function mapFromLegacyPermission(permission: PermissionLegacy): Permission {
	return {
		id: permission.Id,
		key: permission.Key,
		itemId: permission.ItemId,
		userId: permission.UserId,
		unitId: permission.UnitId,
		roleId: permission.RoleId,
		cultureId: permission.CultureId,
		isPublic: permission.IsPublic,
		name: permission.Name,
		relationId: permission.RelationId,
		subPermissions: permission.SubPermissions?.map(mapFromLegacyPermission),
	};
}

/**
 * Maps an array of Permission to PermissionLegacy[], returning a stable reference
 * if the input array reference hasn't changed.
 * Use with useMemo for stable references across re-renders.
 */
export function mapToLegacyPermissions(permissions: Permission[] | undefined): PermissionLegacy[] {
	if (!permissions) return [];
	return permissions.map(mapToLegacyPermission);
}

/**
 * Maps an array of PermissionLegacy to Permission[], returning a stable reference
 * if the input array reference hasn't changed.
 * Use with useMemo for stable references across re-renders.
 */
export function mapFromLegacyPermissions(permissions: PermissionLegacy[] | undefined): Permission[] {
	if (!permissions) return [];
	return permissions.map(mapFromLegacyPermission);
}
